var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctorTatvaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.811035,
    y: 0.444336,
    width: 84,
    height: 84,
    rx: 18.439,
    fill: "url(#paint0_linear_1572_9820)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1572_9820)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.3403,
    y: 16.9521,
    width: 48.6213,
    height: 47.8733,
    rx: 23.9367,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3994 55.0986V69.3123",
    stroke: "#A461D8",
    strokeWidth: 3.6721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1486 33.002H36.2838C35.2946 33.002 34.346 33.3888 33.6466 34.0775C32.9471 34.7662 32.5542 35.7002 32.5542 36.6742V43.1006C32.5542 45.7789 33.6348 48.3475 35.5582 50.2414C37.4817 52.1352 40.0904 53.1992 42.8106 53.1992C45.5308 53.1992 48.1395 52.1352 50.063 50.2414C51.9864 48.3475 53.067 45.7789 53.067 43.1006V36.6742C53.067 35.7002 52.6741 34.7662 51.9746 34.0775C51.2752 33.3888 50.3265 33.002 49.3374 33.002H47.4726",
    stroke: "#A461D8",
    strokeWidth: 3.6721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4717 31.166V34.8396",
    stroke: "#A461D8",
    strokeWidth: 3.6721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1479 31.166V34.8396",
    stroke: "#A461D8",
    strokeWidth: 3.6721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.9939 62.837C67.0992 63.1305 66.8472 63.4279 66.5404 63.3723L53.9363 61.0889C53.6294 61.0333 53.4978 60.6664 53.6994 60.4285L61.979 50.6547C62.1805 50.4167 62.5641 50.4862 62.6693 50.7798L66.9939 62.837Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1572_9820",
    x1: 22.3495,
    y1: 3.67511,
    x2: 68.6572,
    y2: 90.9059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB1EFD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1572_9820"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.3403,
    y: 16.9521,
    width: 48.6213,
    height: 47.8733,
    rx: 23.9367,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorTatvaLogo);
export default __webpack_public_path__ + "static/media/doctor-tatva-logo.65f981759deb927615f81b41f852bd4d.svg";
export { ForwardRef as ReactComponent };